import { EventBus } from '@/plugins/event-bus'
import ControlCodes from 'api-client/ControlCodes.api'

const moduleState = {
  all: [],
  selectedProducts: [],
  loading: true,
}

const getters = {
  all: (state) => state.all,
  selectedProducts: (state) => state.selectedProducts,
  loading: (state) => state.loading,
}

const mutations = {
  /* eslint-disable no-param-reassign */
  setAll: (state, payload) => {
    state.all = payload
    EventBus.$emit('controlCodes/all')
  },
  reset: (state) => {
    state.all = {}
  },
  setLoadingState: (state, payload) => {
    state.loading = payload
    EventBus.$emit('controlCodes/loading')
  },
}

const actions = {
  setAll: ({ commit }, payload) => {
    commit('setAll', payload || [])
    commit('setLoadingState', false)
  },
  async initPurchaseOrderControlCodesForConfigurationCode({ dispatch }, args) {
    if (!args.configurationCode || args.configurationCode.length < 1) {
      return []
    }

    const params = {
      configurationCode: args.configurationCode,
      date: args.deliveryDate,
    }
    const controlCodes = await ControlCodes.getControlCodes(params)

    dispatch('setAll', controlCodes)

    // get Forced controlcodes and controlcodes that where previously selected (and are still available)
    const selectedAndForced = controlCodes.filter((a) => a.Forced || a.ForcedDeselectable)

    dispatch('purchaseOrder/setControlCodes', selectedAndForced, { root: true })
  },
  async getPurchaseOrderControlCodesForConfigurationCode({ dispatch }, args) {
    if (!args.configurationCode || args.configurationCode.length < 1) {
      return []
    }

    const params = {
      configurationCode: args.configurationCode,
      date: args.deliveryDate,
    }

    const controlCodes = await ControlCodes.getControlCodes(params)
    dispatch('updatePurchaseOrderControlCodes', controlCodes)
  },
  async initQuoteOrderControlCodesForConfigurationCode({ dispatch }, args) {
    if (!args.configurationCode || args.configurationCode.length < 1) {
      return []
    }

    const params = {
      configurationCode: args.configurationCode,
      date: args.deliveryDate,
    }
    const controlCodes = await ControlCodes.getControlCodes(params)

    dispatch('setAll', controlCodes)

    // set all forced controlCodes
    const selectedAndForced = controlCodes.filter((a) => a.Forced || a.ForcedDeselectable)

    dispatch('quote/setControlCodes', selectedAndForced, { root: true })
  },
  async initQuoteOrderControlCodesForStockcar({ dispatch }, args) {
    const params = {
      stockCarId: args.stockCarId,
      date: args.deliveryDate,
    }

    const controlCodes = await ControlCodes.getControlCodes(params)
    dispatch('setAll', controlCodes)

    // set all forced controlCodes
    const selectedAndForced = controlCodes.filter((a) => a.Forced || a.ForcedDeselectable)

    dispatch('quote/setControlCodes', selectedAndForced, { root: true })
  },
  async initQuoteOrderControlCodesForStock({ dispatch }, args) {
    const params = {
      stockId: args.stockId,
      date: args.deliveryDate,
    }

    const controlCodes = await ControlCodes.getControlCodes(params)
    dispatch('setAll', controlCodes)

    // set all forced controlCodes
    const selectedAndForced = controlCodes.filter((a) => a.Forced || a.ForcedDeselectable)

    dispatch('quote/setControlCodes', selectedAndForced, { root: true })
  },
  async getQuoteOrderControlCodesForConfigurationCode({ dispatch }, args) {
    if (!args.configurationCode || args.configurationCode.length < 1) {
      return []
    }

    const params = {
      configurationCode: args.configurationCode,
      date: args.deliveryDate,
    }
    const controlCodes = await ControlCodes.getControlCodes(params)

    dispatch('setAll', controlCodes)
    dispatch('updateQuoteControlCodes', controlCodes)
  },
  async getQuoteOrderControlCodesForStockCar({ dispatch }, args) {
    const params = {
      stockCarId: args.stockCarId,
      date: args.deliveryDate,
    }

    const controlCodes = await ControlCodes.getControlCodes(params)
    dispatch('setAll', controlCodes)
    dispatch('updateQuoteControlCodes', controlCodes)
  },
  async getQuoteOrderControlCodesForStock({ dispatch }, args) {
    const params = {
      stockId: args.stockId,
      date: args.deliveryDate,
    }

    const controlCodes = await ControlCodes.getControlCodes(params)
    dispatch('setAll', controlCodes)
    dispatch('updateQuoteControlCodes', controlCodes)
  },
  async updateQuoteControlCodes({ dispatch, rootGetters }, controlCodes) {
    // get Forced controlcodes and controlcodes that where previously selected (and are still available)
    const selectedControlCodes = rootGetters['quote/controlCodes']
    const selectedAndForced = controlCodes.filter(
      (a) => selectedControlCodes.some((b) => a.Id == b.Id) || a.Forced
    )

    if (functions.controlCodeArraysAreDifferent(selectedAndForced, selectedControlCodes))
      EventBus.$emit('notification-warning', 'ControlCodesUpdated')

    dispatch('quote/setControlCodes', selectedAndForced, { root: true })
  },
  async updatePurchaseOrderControlCodes({ dispatch, rootGetters }, controlCodes) {
    dispatch('setAll', controlCodes)
    // get Forced controlcodes and controlcodes that where previously selected (and are still available)
    const selectedControlCodes = rootGetters['purchaseOrder/controlCodes']
    const selectedAndForced = controlCodes.filter(
      (a) => selectedControlCodes.some((b) => a.Id == b.Id) || a.Forced
    )

    if (functions.controlCodeArraysAreDifferent(selectedAndForced, selectedControlCodes))
      EventBus.$emit('notification-warning', 'ControlCodesUpdated')

    dispatch('purchaseOrder/setControlCodes', selectedAndForced, { root: true })
  },
}

const functions = {
  // return true if the arrays are different
  controlCodeArraysAreDifferent(arr1, arr2) {
    const arrA = arr1.map((a) => a.Id)
    const arrB = arr2.map((a) => a.Id)

    // check if any array contains elements that is not in the other
    const result = arrA
      .filter((x) => !arrB.includes(x))
      .concat(arrB.filter((x) => !arrA.includes(x)))

    return result.length > 0
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  functions,
  namespaced: true,
}
